module.exports = __webpack_public_path__ + "static/media/BannerRodapeDesk.2d863fa4.webp";